import BlockAccordion from './BlockAccordion';

export default BlockAccordion;

